import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../context/LoginContext';
import {
  getUserStatus,
  needsCreateProfile,
  needsDesiredPartner,
} from '../utils/onboarding';

/**
 * Member pages (matches, search, chat, etc.) — active members (status 1 or 3 while approval is disabled).
 */
export function RequireActiveMember({ children }) {
  const { isLoggedIn, userData } = useContext(LoginContext);

  if (!isLoggedIn) {
    return <Navigate to="/login/" replace />;
  }

  const status = getUserStatus(userData);

  if (needsCreateProfile(status) || status === null) {
    return <Navigate to="/create-profile" replace />;
  }
  if (needsDesiredPartner(status)) {
    return <Navigate to="/desired-partner" replace />;
  }
  if (status !== 1 && status !== 3) {
    return <Navigate to="/create-profile" replace />;
  }

  return children;
}

/** Create profile — allow incomplete / desired-partner users to fill or edit details. */
export function RequireCreateProfile({ children }) {
  const { isLoggedIn, userData } = useContext(LoginContext);

  if (!isLoggedIn) {
    return <Navigate to="/login/" replace />;
  }

  const status = getUserStatus(userData);

  // Fully approved / active members go to matches
  if (status === 1 || status === 3) {
    return <Navigate to="/recently-joined-matches/" replace />;
  }

  return children;
}

/** Desired partner — status 8 only (profile done, partner form pending). */
export function RequireDesiredPartner({ children }) {
  const { isLoggedIn, userData } = useContext(LoginContext);

  if (!isLoggedIn) {
    return <Navigate to="/login/" replace />;
  }

  const status = getUserStatus(userData);

  // After form submit we set status=1 before leaving this route.
  // Prefer thank-you over dashboard when that handoff flag is set.
  if (status === 1 || status === 3) {
    try {
      if (sessionStorage.getItem('hs_reg_thankyou') === '1') {
        return <Navigate to="/registration-thank-you" replace />;
      }
    } catch (_) {}
    return <Navigate to="/recently-joined-matches/" replace />;
  }
  if (needsCreateProfile(status) || status === null) {
    return <Navigate to="/create-profile" replace />;
  }
  if (!needsDesiredPartner(status)) {
    return <Navigate to="/create-profile" replace />;
  }

  return children;
}

